import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/provider-search/")({
  validateSearch: (search: Record<string, string>) => search,
  beforeLoad: ({ context, search }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/provider-search",
      params: { organizationBusinessUnitId },
      search: {
        lat: search.lat,
        lng: search.lng,
        cityName: search.cityName,
        specialty: search.specialty,
        specialties: search.specialties,
        distance: search.distance,
        employmentTypeIds: search.employmentTypeIds,
        professionalTypeId: search.professionalTypeId,
        professionalTypeName: search.professionalTypeName,
        professionalTypes: search.professionalTypes,
        stateLicenses: search.stateLicenses,
      },
    });
  },
});
